import React, { memo, useState, useCallback, useEffect } from 'react';
import Filter from './components/Filter';
import KeyMetrics from './components/KeyMetrics';
import GroupCharts from './components/GroupCharts';
import BreakdownList from './components/BreakdownList';
import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import { context as Context } from '@gp/components/Context';
import { useRequest } from 'ahooks';
import { fetchStudioOverallProjectsLiveKeyMetricsData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import './index.scss';

interface LivePropsType {}

const DEFAULT_PROPS: LivePropsType = {};

function Live(props: LivePropsType) {
  const {} = props;

  const [filterList, setFilterList] = useState<{
    source: string;
    bo: string[];
    genre: string[];
    genreMap: any[];
    project: string[];
    projectMap: any[];
  }>({
    source: 'internal',
    bo: [],
    genre: [],
    genreMap: [],
    project: [],
    projectMap: [],
  });
  const [filterLoading, setFilterLoading] = useState<boolean>(true);
  // 为了提高接口速率Current Month Gross Revenue/YTM Gross Revenue/MAU三个卡片的数据从breakdown列表接口拿，这里储存这三个卡片的数据和loading
  const [sourceCardMsg, setSourceCard] = useState<{
    loading: boolean;
    data: any;
  }>({
    loading: true,
    data: null,
  });

  const { loading, data, run } = useRequest(
    fetchStudioOverallProjectsLiveKeyMetricsData,
    { manual: true },
  );

  const handleFilterChange = useCallback(
    (payload: {
      source: string;
      bo: string[];
      genre: string[];
      genreMap: any[];
      project: string[];
      projectMap: any[];
    }) => {
      setFilterList(payload);
    },
    [],
  );

  // 筛选器变化
  useEffect(() => {
    // if (filterLoading) return;
    const genreDropArr = filterList?.genreMap
      ?.map((t) => {
        return t?.msg;
      })
      ?.filter((t) => Array.isArray(t));
    let genre: any[] = [];
    for (let i = 0; i < genreDropArr?.length; i++) {
      const t = genreDropArr?.[i];
      genre = [...genre, ...t];
    }

    run({
      internal: filterList?.source === 'internal' ? 'true' : '',
      bo: filterList?.bo,
      genre: genre,
      project_ids: filterList?.projectMap,
    });
  }, [filterList /* filterLoading */]);

  // 页面打点
  useEffect(() => {
    reportOperationLog(
      ALL_REPORT_OPERATION_LOG['STUDIO_OVERALL_PROJECTS_LIVE'],
    );
  }, []);

  return (
    <Context.Provider value={{ filter: filterList, filterLoading }}>
      <div className="dbg-studio-overall-projects-live">
        <div className="dbg-studio-overall-projects-live-filter">
          <Filter
            onChange={handleFilterChange}
            setFilterLoading={setFilterLoading}
          />
        </div>

        <KeyMetrics
          loading={loading /* || filterLoading */}
          data={data}
          sourceCardMsg={sourceCardMsg}
        />
        {/* <GroupCharts loading={loading //|| filterLoading} data={data} /> */}
        <BreakdownList setSourceCard={setSourceCard} />
      </div>
    </Context.Provider>
  );
}

Live.defaultProps = DEFAULT_PROPS;

export default memo(Live);
